import React, { useState, useEffect } from 'react'
import axios from 'axios'
import api from '../components/api'


const Modal = (props) => {

    
    var anexo_id = props.anexo_id
    var pagina_id = props.pagina_id

    //var linkAPI = 'http://172.16.1.253:3600/'
    //var linkAPI = 'https://api.hospitaissaudaveis.org/'
    var linkAPI = process.env.REACT_APP_API

    var ad_usr = sessionStorage.getItem('us_codigo')

    var [file, setFile] = useState()
    var [imagem, setImagem] = useState()
    

    async function salva() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImgAnexo");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagemAnexo", imagefile.files[0]);
                    //formData.append("ad_usr", sessionStorage.getItem('us_codigo')); // string junto ao formData.
                    
                    //console.log('altera')
                    //return false

                    axios.post(`${linkAPI}/paginaAnexo/${pagina_id}/${ad_usr}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        console.log(response.data)
                        window.$("#modalAnexo").modal('hide');
                        //setImagem(response.data.imagem)
                        //setFile('')

                        window.toastr.success('Salvo com sucesso!')



                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    


    function apaga() {

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)

                    api.delete(`anexo/${anexo_id}`).then((result) => {

                        console.log(result.data)
                        //props.carregaBarra()
                        window.$("#modalAnexo").modal('hide');
                        //setBarraLateral_id(result.data[0].barraLateral_id)
                        window.toastr.success('Apagado com sucesso!')

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }




    return (

        <div>


                <div className="modal fade" id="modalAnexo" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Anexo</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Arquivo</label>
                                                <input type="file" className="form-control" id="fileImgAnexo" value={file} onChange={event => setFile(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                        
                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button style={{ display: anexo_id ? 'table-row' : 'none'}} type="button" className="btn btn-danger" onClick={() => apaga()}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )

}


export default Modal
